import type { FilterFieldConfig } from "../components/dashboard/FiltersBar";
import { overviewOptions } from "./executiveOverview";

/** Filter fields shared by the Executive Command Center and the Spend page. */
export const EXECUTIVE_FILTER_FIELDS: FilterFieldConfig[] = [
  { key: "geography", label: "Geography", options: ["All Regions", ...overviewOptions("Geography")] },
  { key: "businessUnit", label: "Business Units", options: ["All BUs", ...overviewOptions("Business_Unit")] },
  { key: "category", label: "Category", options: ["All Categories", ...overviewOptions("Category_L1")] },
  { key: "supplier", label: "Supplier", options: ["All Suppliers", ...overviewOptions("Supplier_Name_Normalized")] },
  { key: "directIndirect", label: "Direct vs Indirect", options: ["Both", "Direct", "Indirect"] },
  { key: "timeframe", label: "Time Period", options: ["Last 3 Years", ...overviewOptions("Year")] },
  { key: "contractStatus", label: "Contract Status", options: ["ALL", ...overviewOptions("Contract_Status")] },
  { key: "tailSpend", label: "Tail Spend", options: ["Include", "Exclude"] },
  { key: "confidence", label: "Confidence", options: ["Any", ">80%", ">90%", ">95%"] },
  { key: "spendRange", label: "Spend Range", options: ["Any", "$0-1M", "$1M-10M", ">$10M"] },
];
